import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IErrorModalComponentData {
  title: string;
  message: string;
  confirmText?: string;
}

@Component({
  template: require('./error-modal.component.html'),
  styles: [require('./error-modal.component.scss')],
})
export class ErrorModalComponent implements OnInit {
  title: string;
  message: string;
  confirmText: string;

  constructor(
    public dialogRef: MatDialogRef<ErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IErrorModalComponentData,
  ) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.message =
      this.data.message || `The batch action could not be applied to all of the selected students. Please try again.`;
    this.confirmText = this.data.confirmText || 'OK';
  }

  onConfirm(): void {
    this.dialogRef.close();
  }
}
